import script from "./ImagesBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesBlock.vue?vue&type=script&setup=true&lang=js"

import "./ImagesBlock.vue?vue&type=style&index=0&id=e61c4256&lang=scss"

const __exports__ = script;

export default __exports__